// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Switch from "@material-ui/core/Switch";
import { Edit } from "@material-ui/icons";
import RemoveRedEye from "@material-ui/icons/RemoveRedEye";
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import axios from "axios";
import Button from "components/CustomButtons/Button.jsx";
import { TransReactTable } from "components/CustomReactTable/TransReactTable";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import moment from "moment";
import React from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import ReactTable from "react-table";
import { api_url } from "redux/config.js";
import Toast from "views/Toast/Toast";

const styles = {
  ...regularFormsStyle,
  ...extendedFormsStyle
};

class CampaignPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showactive: "active",
      campaignData: [],
      active: "pendingTransaction",
      data: [],

      loading: false,
      pages: -1,
      paginationState: null
    };
  }
  componentDidMount() { }
  toggleActivateStateOfSurvey = item => {
    const newActive = !item.active;
    this.props.dispatch({ type: "LOAD_START" });
    const activate_term = newActive ? "campaign/activate" : "campaign/deactivate";
    axios({
      url: api_url + activate_term,
      method: "post",
      data: {
        id: item.id,
        active: newActive
      },
      headers: {
        authorization: "Bearer " + this.props.user.token
      }
    })
      .then(res => {
        if (res.data.success) {
          const newData = this.state.data.map(ditem => {
            let newitem = ditem;
            if (ditem.id === item.id) {
              newitem.active = newActive;
            }
            return newitem;
          });

          this.setState({
            data: newData
          });
          this.normalizeData(newData);
        } else {
          Toast(400, res.data.error);
        }
      })
      .finally(this.props.dispatch({ type: "LOAD_END" }));
  };
  normalizeData = data => {

    if (!data || data.length === 0) {
      this.setState({
        campaignData: []
      });
    }
    const ndata = data.map((item, key) => {
      const view_url = "/campaign/campaign/" + item.id;
      const edit_url = "/sendsurvey/sendsurvey/" + item.id;
      
      const action = (
        <div key={key}>

          <Button
            justIcon
            size="sm"
            color="info"
            onClick={() => this.props.history.push(view_url)}
          >
            <RemoveRedEye />
          </Button>
          <Button
            justIcon
            size="sm"
            color="info"
            onClick={() => this.props.history.push(edit_url)}
          >
            <Edit />
          </Button>
        </div>
      );

      const active = (
        <Switch
          checked={item.active}
          onChange={() => this.toggleActivateStateOfSurvey(item)}
          color="primary"
        />
      );
      // An SMS campaign reaches a phone list, so showing it under an "E-mails" count made every
      // mobile campaign look like it reached nobody. One "Recipients" column reports whichever
      // list the campaign actually uses, with the channel named beside it.
      const channel = item.send_channel || 'email';
      const recipients = channel === 'sms'
        ? `${item.total_phones || 0} 📱`
        : (channel === 'both'
          ? `${item.total_emails || 0} ✉ + ${item.total_phones || 0} 📱`
          : `${item.total_emails || 0} ✉`);
      return {
        campaign_name: item.campaign_name,
        start_date: moment.unix(item.start_date).format("MMMM Do YYYY"),
        recipients,
        active,
        action
      };
    });
    this.setState({
      campaignData: ndata
    });
  };
  loadData = state => {
    this.setState({
      paginationState: state
    });
    this.props.dispatch({ type: "LOAD_START" });
    let data = {
      page: state.page,
      pageSize: state.pageSize,
      sorted: state.sorted,
      filtered: state.filtered
    };
    const showactive = state.showactive || this.state.showactive;
    if (showactive && showactive !== "all") {
      data.active = showactive === "active" ? true : false;
    }
    axios({
      url: api_url + "campaign/get",
      method: "post",
      headers: {
        authorization: "Bearer ".concat(this.props.user.token)
      },
      data
    })
      .then(res => {
        if (res.data.success) {
          this.normalizeData(res.data.data.rows);
          this.setState({
            data: res.data.data.rows,
            pages: res.data.data.pages,
            loading: false
          });
        } else {
          Toast(400, res.data.error);
        }
      })
      .catch(e => {
        Toast(500);
      })
      .finally(() => {
        this.props.dispatch({ type: "LOAD_END" });
      });
  };
  handleactive = showactive => {
    this.setState({
      showactive
    });
    this.loadData({
      ...this.state.paginationState,
      showactive
    });
  };
  render() {
    const { classes,  t } = this.props;

    const column = [
      {
        Header: t("Campaign name"),
        accessor: "campaign_name"
      },
      {
        Header: t("Date"),
        accessor: "start_date"
      },
      {
        Header: t("Recipients"),
        accessor: "recipients"
      },
      {
        Header: t("Active"),
        accessor: "active",
        sortable: false,
        minWidth: 80
      },
      {
        Header: t("Actions"),
        accessor: "action",
        sortable: false,
        minWidth: 150
      }
    ];
    return (
      <div>
        <GridContainer>
          <GridItem md={12} sm={12}>
            <Button color="info" href="/sendsurvey/sendsurvey/0">
              {t('Create')}
            </Button>
            <div style={{ display: 'flex', gap: '15px', alignItems: 'center', margin: '10px 0' }}>
              <label style={{ cursor: 'pointer' }}>
                <input type="radio" name="campaignFilter" value="all" checked={this.state.showactive === 'all'} onChange={() => this.handleactive('all')} /> {t('All')}
              </label>
              <label style={{ cursor: 'pointer' }}>
                <input type="radio" name="campaignFilter" value="active" checked={this.state.showactive === 'active'} onChange={() => this.handleactive('active')} /> {t('Active')}
              </label>
              <label style={{ cursor: 'pointer' }}>
                <input type="radio" name="campaignFilter" value="inactive" checked={this.state.showactive === 'inactive'} onChange={() => this.handleactive('inactive')} /> {t('Inactive')}
              </label>
            </div>
            <TransReactTable
              defaultPageSize={20}
              data={this.state.campaignData}
              columns={column}
              pages={this.state.pages} // should default to -1 (which means we don't know how many pages we have)
              loading={this.state.loading}
              manual // informs React Table that you'll be handling sorting and pagination server-side
              onFetchData={(state, instance) => {
                // show the loading overlay
                this.setState({ loading: true });
                this.loadData(state);
              }}
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

const mapStateToProps = ({ user }) => ({ user });
export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(CampaignPage)));
